import { render, staticRenderFns } from "./jobFair.vue?vue&type=template&id=3d8e19e3&scoped=true&"
import script from "./jobFair.vue?vue&type=script&lang=js&"
export * from "./jobFair.vue?vue&type=script&lang=js&"
import style0 from "./jobFair.vue?vue&type=style&index=0&id=3d8e19e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8e19e3",
  null
  
)

export default component.exports